var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
export var selectLimitedActionInfo = function (state, actionType) {
    var _a = state.limitedActionInfo, limitedAction = _a.limitedAction, createdAt = _a.createdAt;
    var requiredAction = limitedAction.find(function (action) { return action.type === actionType; });
    if (requiredAction) {
        return __assign({}, requiredAction, { createdAt: createdAt });
    }
    return;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectLimitedActionInfo.ts
// module id = 214
// module chunks = 3